// extracted by mini-css-extract-plugin
export var divider = "_s2-0";
export var systemMessage = "_s2-1";
export var systemMessageWrapper = "_s2-2";